import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-prevoyance-gav',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-prevoyance-gav.component.html',
  styleUrls: ['./assurance-prevoyance-gav.component.scss']
})
export class AssurancePrevoyanceGavComponent {
  title = 'Assurance Prévoyance GAV';
  subtitle = 'Garantie des Accidents de la Vie : Protégez-vous contre les aléas du quotidien';
  heroImage = 'assets/static_pages_images/prev-gav.jpg';
  
  breadcrumbs = [
    { label: 'Particuliers', link: undefined },
    { label: 'Assurance Prévoyance GAV', link: undefined }
  ];

  prevPage = { title: 'Mutuelle Santé Internationale',
    link: '/assurance-mutuelle-sante-internationale'
  };

  nextPage = { title: 'Prévoyance IJH',
    link: '/assurance-prevoyance-ijh'
  };

  partners = [
    { name: 'GENERALI', logo: 'assets/logos/GENERALI.PNG' },
    { name: 'BNP', logo: 'assets/logos/BNP.PNG' },
    { name: 'GROUPAMA', logo: 'assets/logos/GROUPAMA.PNG' },
    { name: 'MAIF', logo: 'assets/logos/MAIF.PNG' },
    { name: 'MACIF', logo: 'assets/logos/MACIF.PNG' },
    { name: 'SPVIE', logo: 'assets/logos/SPIVE.PNG' },
    { name: 'MNRA', logo: 'assets/logos/MNRA.PNG' },
    { name: 'CEGEMA', logo: 'assets/logos/CEGEMA.PNG' },
    { name: 'AESIO', logo: 'assets/logos/AESIO.PNG' }
  ];

  constructor(private router: Router) {}

  navigateToComparison(): void {
    this.router.navigate(['/cac/comparaison']);
  }

  navigateToDevis(): void {
    this.router.navigate(['/devis']);
  }
}

